<template>
  <page-edicion>
    <page-header :title="pais.nombre" subtitle="Paises" back-to="/paises" />
    <formulario :pais="pais" @submit="actualizar" />
  </page-edicion>
</template>

<script>
import Formulario from "./Formulario.vue";
import * as paisesApi from "@/services/paises.js";

export default {
  components: { Formulario },
  data() {
    return {
      pais: {},
    };
  },
  mounted() {
    this.cargar(this.$route.params.id);
  },
  methods: {
    cargar(id) {
      paisesApi.cargar(id).then((response) => {
        this.pais = response.pais;
      });
    },
    actualizar() {
      paisesApi.actualizar(this.pais).then(() => {
        this.$messages.success("Se ha actualizado el país");
        this.$router.push({ path: "/paises" });
      });
    },
  },
};
</script>
